import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { UsageHeader } from '@/graphql/contracts/_generated_/contracts';
import { GetVarBillingUsageHeader, GetVarBillingUsageHeaderVariables } from
  '@/graphql/contracts/_generated_/getVarBillingUsageHeader.query';
import GetVarBillingUsageHeaderQuery from '@/graphql/contracts/getVarBillingUsageHeader.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useGetUsageHeaderFromCache(): UsageHeader | null {
  const { fileId }: { fileId: string } = useParams();
  try {
    const usageHeader = apolloClientContracts.cache.readQuery<
    GetVarBillingUsageHeader, GetVarBillingUsageHeaderVariables>({
      query: GetVarBillingUsageHeaderQuery,
      variables: { id: fileId },
    });
    return usageHeader?.varBillingUsageHeader || null;

  } catch (err: any) {
    notificationService.open({
      title: 'Error',
      text: err?.message || 'Something went wrong during loading contract',
      type: 'danger'
    });

    return null;
  }
}
